// extracted by mini-css-extract-plugin
export var bottomRightDecoration = "Q_dv";
export var carouselRow = "Q_dq";
export var description = "Q_dx";
export var image = "Q_g";
export var imageWrapper = "Q_ds";
export var navButton = "Q_dr";
export var section = "Q_d";
export var textOverlay = "Q_dw";
export var title = "Q_h";
export var topLeftDecoration = "Q_dt";